export const CourseConstants = {
  InternalSourceSystem: 'SuccessFactors',
};

export const AppConstants = {
  ResourcesLink: 'https://aka.ms/career',
  LearningLink: 'https://aka.ms/learning',
  CloseMentorshipLink: 'https://aka.ms/AAfs1rz',
  RoleLibrary: 'https://aka.ms/rolelibrary ',
  ValuesLink: 'https://microsoft.sharepoint.com/sites/Values',
  CultureLink: 'https://microsoft.sharepoint.com/sites/Culture/',
  LeadershipPrinciplesLink: 'https://microsoft.sharepoint.com/sites/leadershipprinciples/SitePages/Home.aspx',
  ManagementExcellenceLink: 'https://microsoft.sharepoint.com/sites/ManagementExcellence',
  FAQLink:
    'https://microsoft.sharepoint.com/:w:/r/sites/HRweb/_layouts/15/Doc.aspx?sourcedoc=%7BD1321AC8-035F-448A-8C5E-D950F0604CDC%7D&file=RoleLibraryToolGuide.docx',
};

/**
 * CSS breakpoint queries for responsive design. The breakpoints are as follows:
 *
 * - 1920px wide and wider: xxxl (no media query)
 * - 1366-1919: xxl
 * - 1024-1365: xl
 * - 640-1023: l
 * - 480-639: m
 * - 479px wide and thinner: s
 */
export enum Breakpoints {
  xxl = '@media (max-width: 1919px)',
  xl = '@media (max-width: 1365px)',
  l = '@media (max-width: 1023px)',
  m = '@media (max-width: 639px)',
  s = '@media (max-width: 479px)',
}

export const genericErrorMessage = 'Something went wrong. Please try again later.';

export const copilotErrorMessage = 'Sorry, something went wrong. Please try again or share your feedback.';

/** Width of the panel holding the Copilot chat window */
export const copilotPanelWidth = '425px';

/** Width of the panel holding the Copilot chat window on small screen */
export const copilotPanelWidthOnSmallScreen = '320px';

//** Width of medium screen */
export const mediumScreenWidth = 639;

/** Height of the sticky app header (icon, app name, and tabs) */
export const appHeaderHeight = '54.55px';

//TBD description constant
export const TBDDescriptionMessage = 'TBD';
